import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import type { JSX } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import BackdropLoader from "@entrilia/shared/components/fullScreenLoader/BackdropLoader";
import SmallDialog from "@entrilia/shared/components/SmallDialog";

export interface ConfirmMembersDialogData {
  title: string;
  subtitle?: string;
  description?: string;
  ids: string[];
  confirmCallback?: (ids: string[]) => void;
  confirmButtonLabel: string;
  confirmButtonColor: "primary" | "error";
  icon?: JSX.Element;
}

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data?: ConfirmMembersDialogData;
  isLoading?: boolean;
}

const ConfirmMembersOperationDialog = ({ open, onClose, onConfirm, data, isLoading }: Props) => {
  const { title, subtitle, description, confirmButtonColor, confirmButtonLabel, icon } = data ?? {};

  return (
    <SmallDialog open={open} scroll="paper">
      <DialogTitle>Confirm</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          {icon}
          <Typography variant="h6">{title}</Typography>
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
            {description && <Typography color="textSecondary">{description}</Typography>}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button
          variant={confirmButtonColor === "error" ? "outlined" : "contained"}
          color={confirmButtonColor}
          onClick={onConfirm}
        >
          {confirmButtonLabel}
        </Button>
      </DialogButtons>
      <BackdropLoader open={!!isLoading} />
    </SmallDialog>
  );
};

export default ConfirmMembersOperationDialog;
